import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue'
import { separarLinks } from '@/helpers/link-helpers'


export default /*#__PURE__*/_defineComponent({
  __name: 'TextoComLinks',
  props: {
    texto: null
  },
  setup(__props: any) {

const props = __props as { texto?: string | null };



const trechos = computed(() => separarLinks(props.texto))

return { __sfc: true,props, trechos }
}

})